import uuid from 'uuid/v4';
export const getUUID = () => uuid();